import { Component, OnInit  , ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SavingsinstallmentchangeService } from "../shared/savingsinstallmentchange.service";

@Component({
  selector: 'app-savingsinstallmentchangelist',
  templateUrl: './savingsinstallmentchangelist.component.html',
  styleUrls: ['./savingsinstallmentchangelist.component.css']
})
export class SavingsinstallmentchangelistComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'SavingsId', 'ChangeDate', 'InstallmentAmount', 'InstallmentNo', 'New'];

  changeList$ =[''];

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private savingsinstallmentchangeService : SavingsinstallmentchangeService,
              private router: Router) { }

  ngOnInit() {
    this.getInstallmentChangeList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew()
  {
    this.router.navigate(['/savingsinstallmentchange']);
  }

  getInstallmentChangeList(){
    this.savingsinstallmentchangeService.FetchInstallmentChangeList().subscribe(data =>{
      this.dataSource.data =data;
    })
  }

  Edit(Loan : any){
    this.router.navigate(['/savingsinstallmentchange', Loan.Id]);
  }

}
